export const InputPageMixin = {
    data () {
        return {
            // 会員番号
            member_no: '',
            // ゴルフグループ .env.VUE_APP_GROUP_CODEの値
            golf_groups_val: process.env.VUE_APP_GROUP_CODE,
            // モーダル画面の制御値 MemberCardNoModal
            inputDialog: false,
            // 会員カード追加用ポップアップ表示に関する制御値
            addOverlay: false,
            // 会員カード更新用ポップアップ表示に関する制御値
            changeOverlay: false,
            // 画面のモード指定
            modeStatus: '',
            process: {
            // 処理の結果
                result: '',
                // 処理結果のメッセージ
                resultText: ''
            },
            // エラーメッセージ
            error: '',
            // 登録,削除ボタンクリック時、多重送信防止の状態
            processing: false
        };
    },
    watch: {
        addOverlay () {
            if (this.addOverlay === false) {
                this.process.result = '';
            }
        },
        changeOverlay () {
            if (this.changeOverlay === false) {
                this.process.result = '';
            }
        }
    },
    computed: {
        addModeStatus () {
            return this.modeStatus === 'addMode';
        },
        changeModeStatus () {
            return this.modeStatus === 'changeMode';
        }
    },
    methods: {
        Initialize () {
            this.modeStatus = '';
            this.id = '';
            this.member_no = '';
            this.from_set_data.golf_courses_val = '';
            this.from_set_data.member_class = '2';
            this.from_set_data.card_no = '';
            this.addOverlay = false;
            this.changeOverlay = false;
            this.process.result = '';
            this.process.resultText = '';
            this.dialog = false;
            this.processing = false;
        },
        /** ----------------------------------------------
         * モーダル表示処理 登録状態で表示
         * ---------------------------------------------- */
        addModal () {
            this.Initialize();
            this.modeStatus = 'addMode';
            this.inputDialog = true;
        },
        /** ----------------------------------------------
         * モーダル表示処理 登録状態で表示
         * ---------------------------------------------- */
        editModal (item) {
            this.Initialize();
            this.modeStatus = 'changeMode';
            this.inputDialog = true;
        },
        /** ----------------------------------------------
         * モーダル非表示処理
         * ---------------------------------------------- */
        CloseModal () {
            this.Initialize();
            this.$refs.form.resetValidation();
            this.$emit('refresh-event');
            this.inputDialog = false;
        },
        /** ----------------------------------------------
         * チェック処理
         * ---------------------------------------------- */
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        }
    }
};
